/*
 * Copyright (C) COMPOFFICE-R Kft, RentIT - All Rights Reserved
 * Unauthorized copying of this file, via any medium is strictly prohibited
 * Proprietary and confidential
 *
 */
RCA.client.Useful = (function () {
    'use strict';
    /* ----- Declare Variables ---------------------------------------------------------------------------------------- */
    var $templateUsefulItem;
    var useful;

    /* ----- Init Agenda ---------------------------------------------------------------------------------------------- */
    function Init() {
        $templateUsefulItem = $('template#tplUsefulItem').remove().contents();

        useful = RCA.shared.AppData.docs.filter(function (el) {
            return el.type == "useful" && el.visible;
        });

        renderList();
        renderDetails();
        $(document).on('click', '#useful .item', evtClick);
        delete RCA.client.Useful.Init;
    }

    /* ----- Sort List ------------------------------------------------------------------------------------------------ */
    function sortUseful() {
        useful.sort(function (a, b) {
            return a.title[RCA.shared.localState.lang].localeCompare(b.title[RCA.shared.localState.lang]);
        });
    }

    /* ----- Build Useful List ---------------------------------------------------------------------------------------- */
    function renderList() {
        sortUseful();
        var
            $self = $('#useful #usefulList'),
            $fragmentUseful = $(document.createDocumentFragment()),
            data = useful.filter(function (el) {
                return el.visible === true;
            });
        /* Set Agenda List */
        $.each(data, function (i, el) {
            var $clone = $templateUsefulItem.clone();
            $clone.attr('data-index', el.id);
            $clone.find('.data-title').text(el.title[RCA.shared.localState.lang]);
            $clone.appendTo($fragmentUseful);
        });
        $self.html($fragmentUseful);
    }

    /* ----- Event: Click on Item ------------------------------------------------------------------------------------- */
    function evtClick() {
        RCA.shared.localState.useful = {
            itemIndex: $(this).data('index') || 0
        };
        renderDetails();
        RCA.client.Layout.show('useful-details');
    }

    /* ----- Build Details -------------------------------------------------------------------------------------------- */
    function renderDetails() {
        if ('useful' in RCA.shared.localState) {
            var
                $header = $('#useful-details .data-label'),
                el = useful.find(function (el) {
                    return el.id === RCA.shared.localState.useful.itemIndex
                }) || useful[0];
            if (!el) {
                return false;
            }
            $header.text(el.title[RCA.shared.localState.lang]);
            $('#useful-details embed').attr('src', './pdfjs/web/viewer.html?file=../../upload/docs/' + el.files[RCA.shared.localState.lang].filename);
        }
    }

    function showDetails(id) {
        if (id) {
            if (RCA.shared.localState.useful != undefined) {
                if (id !== RCA.shared.localState.useful.itemIndex || RCA.shared.localState.useful.itemIndex === 0) {
                    RCA.shared.localState.useful.itemIndex = String(id);
                    renderDetails();
                }
            } else {
                RCA.shared.localState.useful = { 'itemIndex': String(id)};
            }
            RCA.client.Layout.show('useful-details');
        }
    }

    /* ----- Build from File ------------------------------------------------------------------------------------------ */
    function BuildFromSource() {
        $.post('api/', {
            do: 'getDocs'
        }, function (data) {
            RCA.shared.AppData.docs = data;
            useful = RCA.shared.AppData.docs.filter(function (el) {
                return el.type == "useful" && el.visible;
            });
            renderList();
            data = null;
        })
    }

    /* ----- Public API ----------------------------------------------------------------------------------------------- */
    return {
        Init: Init,
        showDetails:showDetails,
        BuildFromSource: BuildFromSource
    };
})();
